import {AsyncInlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SellerRepositoriesFactory} from '../Repositories/factory.js'

class GetVehicleDraftLocalStorageSellerUseCase extends UseCase {
  #localStorageRepository

  constructor({localStorageRepository}) {
    super()
    this.#localStorageRepository = localStorageRepository
  }

  static create({config}) {
    return new GetVehicleDraftLocalStorageSellerUseCase({
      localStorageRepository: SellerRepositoriesFactory.localStorageSellerRepository({config})
    })
  }

  @AsyncInlineError()
  async execute() {
    const [error, vehicleDraft] = await this.#localStorageRepository.getVehicleDraft()
    if (error) return Promise.reject(error)
    return vehicleDraft
  }
}

export const factory = GetVehicleDraftLocalStorageSellerUseCase.create
